"use client";

import cn from "@utils/cn";
import { getLink } from "@utils/linkUtils";
import { useLocale } from "next-intl";
import React, { FC, useEffect, useState } from "react";

import AnchorLink from "@/components/ui/AnchorLink/AnchorLink";
import Icon from "@/components/ui/Icon/Icon";
import { BreadcrumbProps, CustomLink } from "@/types";

const Breadcrumb: FC<BreadcrumbProps> = ({ entry, disabledBehaviour, substringNumber }) => {
  const locale = useLocale();
  const [substring, setSubstring] = useState(30);

  useEffect(() => {
    substringNumber && setSubstring(substringNumber);
  }, [substringNumber]);

  let isLast = false;
  return (
    <div className={`flex items-center py-xs font-normal font-secondary text-${entry.color}`}>
      {entry.breadcrumbItems.map((breadcrumb: CustomLink, index: number) => {
        isLast = index === entry.breadcrumbItems.length - 1;

        return (
          <AnchorLink
            href={getLink(breadcrumb, locale).toString()}
            key={`breadcrumb-item-${index}`}
            disabled={disabledBehaviour && breadcrumb.link.linkType != "content" && breadcrumb.link.url === "#"}
            className={cn(
              breadcrumb.link.linkType != "content" && breadcrumb.link.url === "#"
                ? "!bg-transparent"
                : !isLast
                  ? "underline underline-offset-2"
                  : "no-underline",
            )}
            span={isLast}
          >
            <span className={`flex items-center text-s`}>
              {breadcrumb.label.substring(0, substring)}
              {breadcrumb.label.length > substring && "..."}
              {!(breadcrumb.link.linkType != "content" && breadcrumb.link.url === "#") && !isLast && (
                <Icon name="caret-right" size={"20"} className={`stroke-${entry.color}`}></Icon>
              )}
            </span>
          </AnchorLink>
        );
      })}
    </div>
  );
};

export default Breadcrumb;
